<template>
<div class="nettdoc-symptom-location">
  <div class="nettdoc-symptom-location__header">
      <div>
          <img src="../assets/icon-basis-ic-confirm.svg" alt="confirm" @click="submit"/>
      </div>
      <div>
          {{ $t("Please mark the symptoms' location.") }}
      </div>
      <div>
          <img src="../assets/icon-basis-ic-delete.svg" alt="go back" @click="cancel" />
      </div>
  </div>

  <div class="nettdoc-symptom-location__content">
    <SymptomLocationFrontFace v-if="bodypart === 'normalface'" :active="true" :choice="choice" v-on:action="location => setLocation(location)" />
    <SymptomLocationSideFace v-if="bodypart === 'sideface'" :active="true" :choice="choice" v-on:action="location => setLocation(location)" />
    <SymptomLocationFrontBody v-if="bodypart === 'bodyfront'" :active="true" :choice="choice" v-on:action="location => setLocation(location)" />
    <SymptomLocationBackBody v-if="bodypart === 'bodyback'" :active="true" :choice="choice" v-on:action="location => setLocation(location)" />
  </div>
</div>
</template>

<script>
import { observer } from "mobx-vue";
import SymptomLocationFrontFace from './SymptomLocationFrontFace'
import SymptomLocationSideFace from './SymptomLocationSideFace'
import SymptomLocationFrontBody from './SymptomLocationFrontBody'
import SymptomLocationBackBody from './SymptomLocationBackBody'
export default observer({
    name: "SymptomLocation",
    data() {
      return {
        location: this.choice || [],
        tempSelection: []
      }
    },
    props: {
        bodypart: String,
        choice: [String, Array]
    },
    components: {
      SymptomLocationFrontFace, SymptomLocationSideFace, SymptomLocationFrontBody, SymptomLocationBackBody
    },
    methods: {
        submit: function() {
          this.$emit('addvalue', this.location)
          this.$emit('goback')
        },
        cancel: function() {
          this.tempSelection.forEach(selection => {
            if (this.location.indexOf(selection) >= 0) {
              this.location.splice(this.location.indexOf(selection),1)
            } else {
              this.location.push(selection)
            }
          })
          this.$emit('goback')
        },
        setLocation: function(location) {
          if (this.tempSelection.indexOf(location) >= 0) {
            this.tempSelection.splice(this.tempSelection.indexOf(location),1)
          } else {
            this.tempSelection.push(location)
          }

          const locationAlreadyChecked = this.location.indexOf(location)
          if (locationAlreadyChecked >= 0) {
              this.location.splice(locationAlreadyChecked,1)
          } else {
              this.location.push(location)
          }
        }
    }
})
</script>

<style lang="scss">
.nettdoc-symptom-location {
    background-color: #ffffff;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    padding-top: 5%;
    &__header {
        padding: 10px;
        display: grid;
        grid-template-columns: auto auto auto;
        margin: auto;
        text-align: center;
        color: var(--charcoal-grey);
        font-size: 16px;
        font-weight: bold;
        & img {
          cursor: pointer;
        }
    }
    &__content {
      & svg {
        max-height: 90vh;
      }
    }
}
</style>